export const APP_NAME = 'Company Name'
export const APP_DOMAIN_NAME = 'store.vitalgap.com'
export const APP_TAG = 'Your tagline here'
export const FOOTER_LINK = 'https://www.vitalgap.com'
export const FOOTER_TEXT = 'vitalgap.com'
export const FOOTER_YEAR = '2024'
export const EMAIL = 'info@vitalgap.com'
export const CUSTOMER_SUPPORT_PHONE = '+101723233323'
export const ABOUT_US_LINK = 'https://www.vitalgap.com'